<ng-container
  *ngIf="!refreshingChart && chartHasNoData(chartData); else chartWrapper"
>
  <div class="no-data">
    <div class="no-data-content">
      <div class="no-data-text">
        <span>{{ 'Charting.NoDataAvailable' | translate }}</span>
      </div>
    </div>
  </div>
</ng-container>

<ng-template #chartWrapper>
  <ng-container *ngIf="!refreshingChart">
    <ng-container
      *ngIf="chartConfig?.chartType === 'Pie'; then pieChart; else linearChart"
    >
    </ng-container>
  </ng-container>
</ng-template>

<!-- <button (click)="refreshChart()">Refresh</button> -->
<ng-template #linearChart>
  <ejs-chart
    [dataSource]="_chartData"
    [primaryXAxis]="_chartConfig.primaryXAxis"
    [primaryYAxis]="_chartConfig.primaryYAxis"
    [useGroupingSeparator]="_chartConfig.useGroupingSeparator"
    [series]="_chartConfig.chartSeries"
    [pallete]="_chartConfig.palette"
    [theme]="_chartConfig.chartTheme"
    [title]="_chartConfig.chartTitle"
    [subTitle]="_chartConfig.chartSubTitle"
    [titleStyle]="_chartConfig.titleStyle"
    [subTitleStyle]="_chartConfig.subTitleStyle"
    [legendSettings]="_chartConfig.legendSettings"
    [background]="_chartConfig.backgroundColor"
    [chartArea]="_chartConfig.chartArea"
    (load)="chartLoad($event)"
    (chartMouseClick)="onChartClick($event)"
    (legendClick)="onLegendClick($event)"
    (loaded)="onChartLoaded($event)"
    [height]="_chartConfig.chartHeight"
    [width]="_chartConfig.chartWidth"
    [enableAnimation]="false"
    [palettes]="_chartConfig.seriesPalette"
    [axes]="_chartConfig.axes"
    (axisLabelRender)="onAxisLabelRender($event)"
    (pointRender)="onPointRender($event)"
    [annotations]="_chartConfig.annotations"
    [attr.id]="chartId"
    [margin]="_chartConfig.margin"
    (tooltipRender)="onTooltipRender($event)"
    (pointClick)="onPointClick($event)"
    (chartMouseMove)="chartMouseMove($event)"
    [selectionMode]="_chartConfig.selectionMode"
    isMultiSelect='true'
    [selectedDataIndexes]="selectedDataIndexes"
  >
  </ejs-chart>
</ng-template>

<ng-template #pieChart>
  <ejs-accumulationchart
    [dataSource]="_chartData"
    [series]="_chartConfig.chartSeries"
    [legendSettings]="_chartConfig.legendSettings"
    [background]="_chartConfig.backgroundColor"
    [title]="_chartConfig.chartTitle"
    [subTitle]="_chartConfig.chartSubTitle"
    [titleStyle]="_chartConfig.titleStyle"
    [subTitleStyle]="_chartConfig.subTitleStyle"
    [theme]="_chartConfig.theme"
    [height]="_chartConfig.chartHeight"
    [margin]="_chartConfig.margin"
    [attr.id]="chartId"
    (load)="chartLoad($event)"
    (loaded)="onChartLoaded($event)"
  ></ejs-accumulationchart>
</ng-template>
